import React from 'react';
import CentralParcelDetailDrawer from '../../../central/parcels/components/CentralParcelDetailDrawer';

interface OrderDetailDrawerProps {
    orderId: string | null;
    onClose: () => void;
}

/**
 * 罚单申诉详情页点击运单号展示的包裹详情——直接渲染包裹管理的 `CentralParcelDetailDrawer`，
 * 保证内容与样式始终和包裹管理一致（包裹管理后续改动会自动同步到这里）。
 *
 * 纯只读：`embeddedReadOnly` 隐藏门禁码编辑/妥投撤回/实际尺寸编辑（右侧包裹历史照常展示），
 * `hideEditActions` + `hidePrintAndPodReview` 隐藏其余编辑入口与底部操作按钮。
 */
const OrderDetailDrawer: React.FC<OrderDetailDrawerProps> = ({orderId, onClose}) => {
    if (orderId == null) return null;

    return (
        <CentralParcelDetailDrawer
            visible={true}
            onClose={onClose}
            orderId={orderId}
            userRole={''}
            hideEditActions={true}
            hidePrintAndPodReview={true}
            embeddedReadOnly={true}
        />
    );
};

export default OrderDetailDrawer;
